import { render } from "./DownloadModal.vue?vue&type=template&id=055c7d2c&scoped=true"
import script from "./DownloadModal.vue?vue&type=script&lang=js"
export * from "./DownloadModal.vue?vue&type=script&lang=js"

import "./DownloadModal.vue?vue&type=style&index=0&id=055c7d2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-055c7d2c"]])

export default __exports__